import {useContext} from 'react'
import ProductContext from '../contexts/ProductContext.tsx'


import 'cropperjs/dist/cropper.css'
import {useParams} from "react-router-dom"
import ProductForm from "../components/ProductForm.tsx";
import ErrorPage from "../components/ErrorPage.tsx";
import {CircularProgress} from "@mui/material";
import {useTranslation} from "react-i18next";

const EditProductPage = () => {
    const {id} = useParams<{ id: string }>()
    const {t} = useTranslation()
    const {
        updateProductMutation,
        mutateProductError,
        useFetchProduct,
    } = useContext(ProductContext)

    const {data: productResponse, isLoading: loadingProduct, error: errorFetchingProduct} = useFetchProduct(id)

    if (loadingProduct)
        return <CircularProgress sx={{margin: "auto", display: "block"}}/>

    if (errorFetchingProduct)
        return (
            <ErrorPage/>
        )

    return (
        <ProductForm productMutation={updateProductMutation} mutateProductError={mutateProductError}
                     formData={productResponse} submitText={t('UPDATE_PRODUCT_BUTTON_TEXT')}
                     headlineText={t('EDIT_PRODUCT_TEXT')}/>
    )
}

export default EditProductPage